import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { WidgetService } from '../service/widget.service';

@Component({
  selector: 'app-template-multimedia',
  templateUrl: './template-multimedia.component.html',
  styleUrls: ['./template-multimedia.component.css']
})
export class TemplateMultimediaComponent implements OnInit {
  @Input() main_object!: any;
  @Input() main_object_id!: string | null;
  constructor(
    private widgetService: WidgetService,
  ) { }

  file!: File;
  image_tag = 'OT';

  @ViewChild('myInput') myInputVariable!: ElementRef;

  ngOnInit(): void {
  }

  onFilechange(event: any) {
    this.file = event.target.files[0]
  }
  fnRemove(index: number) {
    this.main_object.pictures.splice(index, 1);
  }

  fnUploadImage() {
    if (this.file) {
      const _header = {
        content_type: "image/png"
      };
      this.widgetService.postUploadEndpoint(_header, this.file).subscribe(
        (x) => {
          const _pictures = [];
          if (this.main_object_id) {


            const new_picture =
            {
              file_name: x.data.file_name,
              tag: this.image_tag,
            };
            _pictures.push(new_picture);
            this.main_object.pictures.map(
              (_obj: any) => {
                _pictures.push(_obj);
              }
            )
            this.main_object.pictures = _pictures;


          } else {


            const new_picture = {
              file_name: x.data.file_name,
              // tag: this.image_tag,
              category: this.image_tag,
            };
            _pictures.push(new_picture);
            this.main_object.pictures.map(
              (_obj: any) => {
                _pictures.push(_obj);
              }
            );
            this.main_object.pictures = _pictures;


          }
          this.myInputVariable.nativeElement.value = "";
          this.image_tag = 'OT';
        }
      );
    } else {
      alert("Please select a file first")
    }
  }
}
